<template>
  <div class="row">
    <div v-for="color in colors" :key="color" class="col-lg-3 col-xs-12">
      <div
        class="card mb-2 full pt-3 pb-2 pointer"
        :class="color === selected ? 'selectedDiv' : 'selectDiv'"
        @click="selectColor(color)"
        :style="{ backgroundColor: `${color}`, height: '10px' }"
      ></div>
    </div>
  </div>
</template>

<script>
export default {
  mounted() {
    eventBus.$on("deselectColor", (color) => {
      this.selected = color;
    });
  },
  data: () => ({
    selected: "",
    colors: [
      "#FF0000",
      "#FFA500",
      "#FFFF00",
      "#964B00",
      "#0000FF",
      "#4B0082",
      "#808080",
      "#000000",
    ],
  }),
  watch: {
    selected: function () {
      this.$emit("input", this.selected);
    },
  },
  methods: {
    selectColor(color) {
      this.selected = color;
    },
  },
};
</script>